// Simple, reliable client-side file downloaders.
// These work on real domains (Hostinger, Netlify, Vercel, etc).
// Inside a sandboxed preview iframe they may be blocked — callers should fall back
// to `window.open(blobUrl)` so the user can save manually.

export function downloadJSON(filename, data) {
  return downloadText(filename, JSON.stringify(data, null, 2), "application/json");
}

// Convenience wrapper for the styled product HTML doc.
export function downloadHtml(filename, htmlString) {
  return downloadText(filename, htmlString, "text/html");
}

export function downloadText(filename, text, mime = "text/markdown") {
  try {
    const blob = new Blob([text], { type: `${mime};charset=utf-8` });
    triggerBlobDownload(blob, filename);
    return true;
  } catch {
    return false;
  }
}

export function downloadDataUrl(filename, dataUrl) {
  try {
    const blob = dataUrlToBlob(dataUrl);
    triggerBlobDownload(blob, filename);
    return true;
  } catch {
    return false;
  }
}

function triggerBlobDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  // Leave the anchor + URL alive long enough for the browser to start the download.
  setTimeout(() => {
    try { a.remove(); } catch {}
    URL.revokeObjectURL(url);
  }, 4000);
}

function dataUrlToBlob(dataUrl) {
  const [meta, body] = dataUrl.split(",");
  const mime = (meta.match(/data:([^;]+)/) || [])[1] || "application/octet-stream";
  const isB64 = /;base64/i.test(meta);
  if (!isB64) return new Blob([decodeURIComponent(body)], { type: mime });
  const binary = atob(body);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return new Blob([bytes], { type: mime });
}

export function slugify(s, fallback = "product") {
  if (!s) return fallback;
  return s.toString().toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 60) || fallback;
}
